// generated by the plop

import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { GpsLocationService } from 'shared';
import { RequestLocations, UpdateGpsLocationMaster } from './gps-location.actions';

@State({ name: 'GpsLocation' })
@Injectable()
export class GpsLocationState {

  constructor(private gpsLocationService: GpsLocationService) {
  }

  @Action(UpdateGpsLocationMaster)
  updateGpsLocationMaster(ctx: StateContext<UpdateGpsLocationMaster>, { master }: UpdateGpsLocationMaster): void {
  }

  @Action(RequestLocations)
  requestLocations(ctx: StateContext<RequestLocations>): void {
    this.gpsLocationService.requestLocations().subscribe();
  }
}


